import { NgModule, ModuleWithProviders } from '@angular/core';
import { ProductLibComponent } from './product-lib.component';
import { ProductLibService } from './product-lib.service';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
  declarations: [ProductLibComponent],
  imports: [
    HttpClientModule
  ],
  exports: [ProductLibComponent]
})
export class ProductLibModule {
  public static forRoot(environment: any): ModuleWithProviders<any> {

    return {
      ngModule: ProductLibModule,
      providers: [
        ProductLibService,
        {
          provide: 'environment', // you can also use InjectionToken
          useValue: environment
        }
      ]
    };
  }
 }
